import { motion } from "motion/react";


const leadershipTeam = [
  {
    name: "Wekesa N. Wafula",
    role: "Executive Director",
    image: "/executive-director.png",
    bio: "Wekesa is a founder director of Hilltop Preparatory School since its inception in 2005. He has been instrumental in the funding, strategic development, operations and growth of the school from its humble beginning to date. He is a versatile professional with more than 22 years of management and leadership experience in the telecommunications section; Wekesa is a strategist and an adept project manager with exceptional skill in project actualization. He holds an MBA from Maastricht / ESAMI school of Business Management and is an Engineering graduate from Jomo Kenyatta University of Agriculture and Technology. He also has certification in Project Management, Sales Management and the Chartered Institute of Marketing (CIM).",
    
  },
  {
    name: "Catherine Wanjike Naliaka Wafula-Ondeng'",
    role: "Director",
    image: "/director.png",
    bio: "Catherine is a founder director of Hilltop Preparatory School since 2005. Catherine has an undergraduate degree in Education (Home Economic), a Master of Science in Maternal and Child Health, Masters of Arts in Child development, She holds a Post Graduate Diploma in Project Planning and Management, Counselling from the University of Nairobi and Daystar University respectively and a Diploma in Human Resource Management from Kenya Institute of Human Resource Management. Catherine is currently pursuing her Doctorate (PhD) in Child Psychology at the University of Stellenbosch in Cape Town, South Africa.",
    
  },
  {
    name: "Terry Gathoni Wafula",
    role: "Director",
    image: "/director-2.png",
    bio: "Terry has been a Director of Hilltop Preparatory School since 2005. Terry is a holder of a Higher Diploma in Management of Information Systems (MIS UK), an undergraduate degree in International Business Administration (USIU- Africa) and an Executive Masters in Business Administration (Columbia Business School USA). She is currently pursuing her Doctor of Business Administration in USIU – A, Kenya.",
    
  },
];

export function Leadership() {
  return (
    <div>
      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-slate-900 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-20 right-10 w-72 h-72 bg-red-500/20 rounded-full blur-3xl" />
          <div className="absolute bottom-10 left-10 w-96 h-96 bg-blue-400/20 rounded-full blur-3xl" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white/90 text-sm font-medium mb-6 border border-white/20"
          >
            Meet Our Team
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-5xl sm:text-6xl font-bold text-white mb-6"
          >
            School Leadership
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xl text-white/80 max-w-2xl mx-auto"
          >
            Dedicated professionals committed to guiding our school community
            towards excellence.
          </motion.p>
        </div>
      </section>

      {/* Leadership Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {leadershipTeam.map((leader, index) => (
              <motion.div
                key={leader.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group"
              >
                <div className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-slate-100">
                  {/* Image */}
                  <div className="relative h-72 overflow-hidden">
                    <img
                      src={leader.image}
                      alt={leader.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" />

                    {/* Role Badge */}
                    <div className="absolute bottom-4 left-4 right-4">
                      <span className="inline-block px-3 py-1 bg-red-600 text-white text-sm font-medium rounded-full">
                        {leader.role}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-slate-900 mb-2">
                      {leader.name}
                    </h3>
                    <p className="text-slate-600 text-sm leading-relaxed mb-4">
                      {leader.bio}
                    </p>                   
                    
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Message from Director */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-slate-100"
          >
            <div className="flex flex-col md:flex-row gap-8 items-center">
              <div className="flex-shrink-0">
                <img
                  src="/executive-director.png"
                  alt="Executive Director"
                  className="w-32 h-32 rounded-2xl object-cover shadow-lg"
                />
              </div>
              <div>
                <span className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium mb-4">
                  Message from the Executive Director
                </span>
                <p className="text-lg text-slate-600 leading-relaxed mb-4">
                  "At Hilltop Preparatory, we believe that every child is unique
                  and capable of greatness. Our leadership team is committed to
                  creating an environment where students are challenged to excel
                  academically while developing the character and values that
                  will serve them throughout their lives."
                </p>
                <p className="text-slate-900 font-semibold">Wekesa N. Wafula</p>
                <p className="text-slate-500 text-sm">Executive Director</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
